import * as CommonApi from '@/services/common';
import { setToken } from '@/utils/common/storage';
import isApp from '@/utils/ua';

// import { setToken } from '@/utils/common/storage';
import { useErrorMsg } from './useErrorMsg';
import { useUserProfile } from './useUserProfile';

export function useLogout() {
  const { mutate } = useUserProfile();
  const { msgError } = useErrorMsg(mutate);
  const logout = () => {
    CommonApi.logout()
      .then(() => {
        isApp() && setToken(''); // TODO： 登出操作删除token代码还保留吗？
        const lang = localStorage.BYBIT_LANG_KEY || 'en';
        setTimeout(() => {
          window.location.href = location.origin + '/' + lang + '/login';
        }, 1500);
      })
      .catch((error) => {
        msgError(error);
      });
  };

  return logout;
}
